import React, { useState, useCallback, useEffect } from 'react'
import GridLayout from '../_layouts/grid-layout'
import { ApolloProvider } from '@apollo/client'
import { client } from '../_includes/forstok'
const Homepage = () => {
  let  welcomeText = ''; 

  return (
    <ApolloProvider client={client}><GridLayout>
    <div>
      {welcomeText}
    </div>
    </GridLayout>
    </ApolloProvider>
  )
}

export default Homepage;
